type LogInfo = {
  prefix: string;
  msg: string;
  data: any;
  desc: string;
};

type CreateLoggerOptions = {
  onBefore?: (logInfo: LogInfo) => void;
  onAfter?: (logInfo: LogInfo) => void;
  prefix?: (() => string) | string;
  logColor?: LogColor;
  enableLog?: boolean | ((logInfo: LogInfo) => boolean);
  remoteLoggerUrl?: string | ((defaultPath: string) => string);
};

type LogColor = {
  info?: string;
  warn?: string;
  error?: string;
  log?: string;
};

type logFn = (msg: string, data?: any) => {};

export interface Logger {
  info: logFn;
  warn: logFn;
  error: logFn;
  log: logFn;
}

export const createLogger = (options: CreateLoggerOptions) => {
  let { onBefore, onAfter, prefix, logColor, enableLog = true } = options;

  const defaultLogColor = {
    info: "blue",
    warn: "orange",
    error: "red",
    log: "green",
  };
  const mergredLogColor = Object.assign(defaultLogColor, logColor);

  function log(...args: [string, string, any, "log" | "info" | "warn" | "error"]) {
    const [color, msg, data] = args;
    const prefix = getPrefix();
    const logInfo = {
      prefix,
      msg,
      data,
      desc: prefix + msg,
    };
    onBefore && onBefore(logInfo);
    const shouldLog = typeof enableLog === "function" ? enableLog(logInfo) : enableLog;
    if (shouldLog) console.log(`%c ${logInfo.desc}`, `color: ${color};`, logInfo.data);
    onAfter && onAfter(logInfo);
  }

  function getPrefix() {
    return typeof prefix === "function" ? prefix() : prefix || "";
  }

  return {
    log(msg, data) {
      log(mergredLogColor.log, msg, data, "log");
    },
    info(msg, data) {
      log(mergredLogColor.info, msg, data, "info");
    },
    warn(msg, data) {
      log(mergredLogColor.warn, msg, data, "warn");
    },
    error(msg, data) {
      log(mergredLogColor.error, msg, data, "error");
    },
  } as Logger;
};
